<template>
  <div>
    <div @click="toggleDropdown" class="dropdown-toggle nav-item">
      {{ MyCategory.FormKbn.find((item) => item.Kbn == 2)?.KbnName }}
    </div>
    <StaffSelect
      :isModalStaffSelectVisible="isModalStaffSelectVisible"
      :staffSelectId="StaffSelectId"
      @selected-action="selectedActionStaffSelect"
      @cancel-action="cancelActionStaffSelect"
    />
    <div v-if="isOpen" class="dropdown-menu">
      <!-- <router-link  to="#"  class="dropdown-item"  @click="redirectToManage">会社情報</router-link>
      <router-link to="/role" class="dropdown-item" @click="closeDropdown" v-if="companyService.role && companyService.role.includes('Admin')">役割</router-link>
      <router-link to="/master/staffList" class="dropdown-item" @click="closeDropdown">スタッフマスター</router-link>
      <router-link to="/master/userList" class="dropdown-item" @click="closeDropdown">利用者マスター</router-link>
      <router-link to="/master/officeList" class="dropdown-item" @click="closeDropdown"> 事業所マスター</router-link>
      <router-link to="/master/syohinList" class="dropdown-item" @click="closeDropdown">商品マスター</router-link>
      <router-link to="/master/tani" class="dropdown-item" @click="closeDropdown">単位マスター</router-link>-->
      <!-- <router-link
        to="/userMemo"
        class="dropdown-item"
        @click="closeDropdown"
        >利用者メモ</router-link
      > -->
      <button class="dropdown-item" @click="openInNewTab('/userMemo')">利用者メモ</button>

      <div
        v-for="(staffRole, index) in StaffRole.filter((item:TblMStaffRole) => item.kbn == 2 && item.roleKbn ==1)"
        :key="index"
      >
        <router-link
          :to="staffRole.url ?? ''"
          class="dropdown-item"
          @click="closeDropdown"
          >{{ staffRole.menuName }}</router-link
        >
      </div>

      <!-- <router-link
        to="/homonKaigoKeikaku2"
        class="dropdown-item"
        @click="closeDropdown"
        >訪問介護計画入力2</router-link
      > -->

      <!-- <router-link
        to="/visitingNurseRecordII"
        class="dropdown-item"
        @click="closeDropdown"
        >訪問看護記録書Ⅱ</router-link
      >
      <router-link to="/visitingNursePlan" class="dropdown-item" @click="closeDropdown"
        >訪問看護計画書</router-link
      >
      <router-link to="/visitingNurseReport" class="dropdown-item" @click="closeDropdown"
        >訪問看護報告書</router-link
      >
      <router-link to="/counter" class="dropdown-item" @click="closeDropdown"
        >Counter</router-link
      >
      <router-link to="/fetch-data" class="dropdown-item" @click="closeDropdown"
        >Fetch data</router-link
      >
      <router-link to="/fileupload" class="dropdown-item" @click="closeDropdown"
        >FileUpload</router-link
      >
      <router-link to="/pdf" class="dropdown-item" @click="closeDropdown"
        >PDF</router-link
      >
      <router-link to="/myFullCalendar" class="dropdown-item" @click="closeDropdown"
        >FullCalendar</router-link
      > -->
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, inject, onMounted } from "vue";
import type { Ref } from "vue";
import { RouterLink } from "vue-router";
import router from "@/router";
import CompanyService from "../Js/CompanyService";
import StaffSelect from "@/components/StaffSelect.vue";
import { useStaffSelect } from "@/Js/StaffSelectService";
import StaffSelectService from "@/Js/StaffSelectService";
import MyCategory from "@/Data/MyCategory";
import { TblMStaffRole } from "@/models/TblMStaffRole";
import type { ITblMStaffRoleData } from "@/models/TblMStaffRole";
import axios, { Axios, type AxiosResponse } from "axios";

const companyService = CompanyService; //会社情報、既にexport default new CompanyService();をしている。
const staffSelectService = new StaffSelectService();
const StaffRole: Ref<TblMStaffRole[]> = ref([new TblMStaffRole()]);

const {
  StaffSelectId,
  isModalStaffSelectVisible,
  showStaffSelect,
  closeModalStaffSelect,
  cancelActionStaffSelect,
  selectedActionStaffSelect,
} = useStaffSelect();

const openStaffSelect = () => {
  showStaffSelect(() => {});
};

const modal = inject("modal") as {
  showModalYesNo: (
    title: string,
    message: string,
    actionYesCallback?: () => void,
    actionNoCallback?: () => void
  ) => Promise<void>;
};

const isOpen = ref(false);

const props = defineProps({
  isOpenMenu2: Boolean,
});

const toggleDropdown = async() => {
  const company = companyService.getStoredData();
  if (
    company.companyCode != "" &&
    company.officeCode != "" &&
    company.serviceType != ""
  ) {
    if ((staffSelectService.getStaffSelect().staffCode ?? "") == "") {
      await openStaffSelect();
    } else {
      isOpen.value = !isOpen.value;
    }
    await getList();
  }
};

const closeDropdown = () => {
  isOpen.value = false;
};

const openInNewTab = async (path: string) => {
  const callbackYes = async () => {
    const url = router.resolve(path).href;
    window.open(url, "_blank");
    closeDropdown();
  };

  const callbackNo = async () => {
    const url = router.resolve(path).href;
    window.location.href = url; // 現在のタブで開く
    closeDropdown();
  };

  await modal.showModalYesNo(
    "利用者メモ",
    "別タブで開きますか？",
    callbackYes,
    callbackNo
  );
};

const getList = async () => {
  try {

    const staffCode:string = staffSelectService.getStaffSelect().staffCode?? '' ;
    if (staffCode && StaffRole.value.length==0) {
      const endpoint: string = `${
        import.meta.env.VITE_API_TARGET
      }/api/MStaffRole/GetListsByStaffCode/${
        staffCode ?? ""
      }`;

      const response = await axios.get(endpoint);
      let staffRole: TblMStaffRole[] = [new TblMStaffRole()];

      if (response.status === 200) {
        staffRole = response.data.map((item: TblMStaffRole) => {

          // 新しいユーザーオブジェクトを作成し、変換された日付を使用
          return new TblMStaffRole({
            ...item,
           });
        });

        StaffRole.value=staffRole;
      }
    }
  } catch{

  }
};

onMounted(async () => {
   axios.defaults.withCredentials = true; //Cookieの場合
  StaffRole.value =[];
});

watch(
  () => props.isOpenMenu2,
  (newValue, oldValue) => {
    if (newValue !== oldValue && newValue == true) {
      isOpen.value = false;
    }
  }
);
</script>

<style scoped>
.dropdown-toggle {
  cursor: pointer;
  padding: 8px;
  background-color: #007bff;
  color: white;
}

.dropdown-menu {
  position: fixed;
  display: block;
  background-color: white;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  max-height: 50vh;
  overflow-y: auto;
  z-index: 9000 !important;
}

.dropdown-item {
  padding: 8px;
  display: block;
  color: black;
  text-decoration: none;
}

.dropdown-item:hover {
  background-color: #f0f0f0;
}
</style>
